<template>
	<article
		:class="{ 'is-deleting': isDeletingItem }"
		class="cart-item"
	>
	<button
		@click="deleteCartItem"
		:disabled="this.isUpdatingItem"
		class="btn btn--plain cart-item__delete hidden-sm-up"
	>
		<i class="icon icon-bin"></i>
	</button>
		<div class="row push-half-bottom">
			<div class="col-xxs-4 col-sm-5 col-md-3">
				<div class="cart-item__img-container">
					<img
						:src="item.image_url"
						:alt="item.title"
						class="cart-item__img img-responsive"
						loading="lazy"
					/>
				</div>
			</div>
			<div class="col-xxs-8 hidden-sm-up">
				<h2
					v-html="item.title"
					class="cart-item__title"
				></h2>
			</div>
			<div class="col-xxs-12 col-sm-7 col-md-9 push-top">
				<div class="row push-bottom">
					<div class="col-xxs-12 col-sm-8 hidden-sm-down">
						<h2
							v-html="item.title"
							class="cart-item__title"
						></h2>

						<div 
							v-if="extraSubtitle.length"
							v-html="extraSubtitle"
							class="cart-item__subtitle"
						></div>
					</div>
					<div class="col-xxs-12 col-sm-4 hidden-sm-down">
						<button
							@click="deleteCartItem"
							:disabled="this.isUpdatingItem"
							class="btn btn--plain cart-item__delete"
						>
							<span class="cart-item__delete__label">Delete</span>
							<i class="icon icon-bin"></i>
						</button>
					</div>
				</div>
				<div class="row">
					<div class="col-xxs-12">
						<div
							v-html="getItemContent"
							class="cart-item__content"
						>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row push-top soft-top">
			<div class="col-xxs-6 col-sm-4">
				<div class="product__quantity__input-container flex">
					<button
						@click="decreaseQty"
						:disabled="1 >= item.quantity"
						class="btn btn--black product__quantity__btn product__quantity__btn--subtract"
					>&minus;</button>
					<input
						@change="handleQtyInput( $event.target.value )"
						:value="item.quantity"
						class="product__quantity__input"
						type="number"
						min="1"
					/>
					<button
						@click="increaseQty"
						class="btn btn--black product__quantity__btn product__quantity__btn--add"
					>&plus;</button>
				</div>
			</div>
			<div class="col-xxs-6 col-sm-4">
				<div class="cart-item__price">{{ getPrettyPrice }} each</div>
			</div>
			<div class="col-xxs-12 col-sm-4">
				<button
					@click="$emit( 'edit_cart_item' )"
					:disabled="this.isUpdatingItem"
					class="cart-item__edit"
				>
					<i class="icon icon-pen"></i>
					<span class="cart-item__edit__label">Edit Item</span>
				</button>
			</div>
			<div
				v-if="status.text.length"
				class="col-xxs-12"
			>
				<div
					v-html="status.text"
					:class="{ 'is-error': status.isError, 'is-success': status.isSuccess }"
					class="add-status"
				></div>
			</div>
		</div>
	</article>
</template>


<script>
	import _isEmpty from 'lodash.isempty'

	import WpApi from '../helpers/WpApi.mjs'
	import PriceFormatter from '../helpers/PriceFormatter.mjs'


	export default {
		name: 'CartItem',
		props: {
			item: {
				type: Object,
				required: true
			},
		},

		data() {
			return {
				updateQtyTimeout: 	null,
				isDeletingItem: 	false,
				isEditingItem: 		false,
				isUpdatingItem: 	false,
				status: {
					isError: 	false,
					isSuccess: 	false,
					text: 		''
				}
			}
		},

		computed: {
			getPrettyPrice() {
				return PriceFormatter.formatToPrice( this.item.price )
			},

			getItemContent() {
				let content = this.item.content

				// check for active addons
				if( !_isEmpty( this.item.addons ) ) {
					const addons 	= this.item.addons,
						itemExtras 	= []

					for( const addonKey in addons ) {
						const options = addons[ addonKey ].options

						for( const optionKey in options ) {
							const option = options[ optionKey ]

							if( option.active ) {
								itemExtras.push( option.title ) // e.g. "Extra Dressing ($0.50)"
							}
						}
					}

					if( itemExtras.length ) {
						content += ` &mdash; ${itemExtras.join( ', ' )}`
					}
				}

				return content
			},

			// if cart item is an Extra variation), show variation name
			extraSubtitle() {
				let title = '' 

				if( this.item.is_extra && this.item.is_variation ) {
					title = this.item.variations[ this.item.id ].extra_name
				}

				return title
			},
		},


		methods: {
			deleteCartItem() {

				// avoid deleting twice
				if( this.isDeletingItem ) {
					return
				}

				// signal to user process has begun
				this.isDeletingItem = true
				this.status.text 	= 'Deleting cart item'

				WpApi
					.deleteItemFromCart( this.item.cart_item_key )
					.then( response => {

						// error will be a string; success will be boolean to send to parent to indicate product was deleted
						if( 'string' === typeof response ) {
							this.setStatusError( response )
						} else {
							this.setStatusSuccess( 'Deleted cart item!' )
							this.$emit( 'handle_delete_cart_item' )
						}

						this.isDeletingItem = false
					})
			},


			increaseQty() {
				this.item.quantity++

				this.maybeUpdateQty()
			},


			decreaseQty() {
				if( 1 < this.item.quantity ) {
					this.item.quantity--
				}

				this.maybeUpdateQty()
			},


			handleQtyInput( qty ) {
				qty = parseInt( qty )

				if( isNaN( qty ) || 1 > qty ) {
					qty = 1
				}

				this.item.quantity = qty
				this.maybeUpdateQty()
			},


			maybeUpdateQty() {
				if( null !== this.updateQtyTimeout ) {
					clearTimeout( this.updateQtyTimeout )
				}

				this.updateQtyTimeout = setTimeout( this.submitUpdatedQty, 1000 )
			},


			submitUpdatedQty() {
				const { cart_item_key, quantity } = this.item

				this.isUpdatingItem = true

				WpApi
					.updateItemQuantity( cart_item_key, quantity )
					.then( () => this.isUpdatingItem = false )
			},


			setStatusError( msg = '' ) {
				this.resetStatus()

				if( msg.length ) {
					this.status.isError = true
					this.status.text 	= msg
				}
			},


			setStatusSuccess( msg = '' ) {
				this.resetStatus()

				if( msg.length ) {
					this.status.isSuccess 	= true
					this.status.text 		= msg
				}
			},


			resetStatus() {
				if( !this.isDeletingItem ) {
					this.status = {
						isError: 	false,
						isSuccess: 	false,
						text: 		''
					}
				}
			},
		},
	}
</script>
